document.addEventListener("DOMContentLoaded", async function() {
  const relatedContainer = document.querySelector(".technology-video .related");
  if (relatedContainer) {
    const response = await fetch(relatedContainer.dataset.relatedUrl);
    relatedContainer.innerHTML = await response.text();
  }
});
